import * as React from "react";
import { Link } from "react-router";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { Auth } from "../../utils/auth";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import { Category } from "../../models/category";
import FeaturedContent from "../../components/widgets/featuredContent";
import FeaturedOps from "../../components/opportunity/featuredOps";
import RecommendedOps from "../../components/opportunity/recommendedOps";
import Categories from "../../components/categories";
import FilteredOps from "../../components/opportunity/filteredOps";
import InboxIcon from 'material-ui-icons/Inbox';
import Divider from 'material-ui/Divider';
import { Row, Col, Grid } from "react-flexbox-grid";
import { ScreenMode } from "../../models/enums";
import SvgIcon from 'material-ui/SvgIcon';
import StartVw from "../start";
import * as s from "./landing.css";
import { ILocalization } from "../../models/localization";
import { Paper } from "material-ui";

@inject("store") @observer
export default class Landing extends React.Component<{ store: SeekerStore }, {}> {
  private searchBarRef: HTMLDivElement;
  private recommendedOpsRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.searchBarRef = null;
    this.recommendedOpsRef = null;
  }
  componentWillMount(): void {
    window.scrollTo(0, 0); 
  }

  componentDidMount(): void {
    if (this.props.store.viewState.scrollToSearchBar) {
      this.scrollToSearchBar();
    } 
    if (this.props.store.viewState.scrollToRecommendedOps) {
      this.scrollToRecommendedOps();
    }
    this.props.store.getHelpTopics();
  }

  componentDidUpdate() {
    if (this.props.store.viewState.scrollToSearchBar) {
      this.scrollToSearchBar()   
    }
    if (this.props.store.viewState.scrollToRecommendedOps) {
      this.scrollToRecommendedOps()
    }
  }

  scrollToSearchBar = () => {
    this.searchBarRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    this.props.store.viewState.setScrollToSearchBar(false);
  }

  scrollToRecommendedOps = () => {
    this.recommendedOpsRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "instant" });
    this.props.store.viewState.setScrollToRecommendedOps(false);
  }

  renderAnon(): JSX.Element {
    return (<div><section><StartVw store={this.props.store} /></section></div>)
  }

  renderLandingVideo(local: ILocalization): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const videoUrl: string = local.videoUrl + "?title=0&byline=0&portrait=0";
    const paper: any = { backgroundColor: "#F6F8F8" };
    return (<Paper elevation={4} style={paper} className={s.container}>
          <div className={s.wrapper}><iframe src={videoUrl} height="320" width="180" frameBorder="0" allowFullScreen ></iframe></div>
      </Paper>)
  }

  renderAuth(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div>
      <section className={s.featureSection}>
        <FeaturedContent store={this.props.store} />
      </section>
      {(typeof local.videoUrl !== 'undefined' && local.videoUrl !== "") && this.renderLandingVideo(local)}
      <section className={s.featuredOpsSection}>
        <FeaturedOps store={this.props.store} />
      </section>
      <section className={s.recommendedOpsSection}>
        <div style={{ float: "left", clear: "both" }} ref={(el) => { this.recommendedOpsRef = el; }}></div>
        <RecommendedOps store={this.props.store} />
      </section>
      <section className={s.categorySection}>
        <Categories store={this.props.store} />
      </section>
      <section className={s.searchSection} >
        <div style={{ float: "left", clear: "both" }} ref={(el) => { this.searchBarRef = el; }}></div>
        <FilteredOps store={this.props.store} />
      </section>
    </div>);
  }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<div>
      {Auth.isAuthenticated && this.renderAuth()}
      {!Auth.isAuthenticated && this.renderAnon()}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/views/landing/index.tsx